import React from "react";
import { OperatorEmblem } from "./OperatorEmblem";
import { LoadoutBrief } from "./LoadoutStrip";

export const OperatorMiniCard = ({ operator, side, index, locked = true, loadout = null }) => {
  const accent = side === "attacker" ? "#E67300" : "#1F88E8";
  return (
    <div
      data-testid={`team-slot-${index}`}
      className={`relative border bg-neutral-950/80 p-4 flex flex-col items-center text-center min-h-[180px] r6-pop-in ${!locked ? "opacity-95" : ""}`}
      style={{ borderColor: `${accent}55` }}
    >
      <div
        className="absolute top-2 left-2 text-[10px] tracking-[0.2em] font-bold"
        style={{ color: accent, fontFamily: '"JetBrains Mono", monospace' }}
      >
        0{index + 1}
      </div>
      <OperatorEmblem id={operator.id} name={operator.name} side={side} size={76} />
      <div
        className="mt-3 text-white text-lg font-black uppercase tracking-tight leading-tight"
        style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
      >
        {operator.name}
      </div>
      <div
        className="text-[10px] text-neutral-500 tracking-[0.2em] uppercase mt-1"
        style={{ fontFamily: '"JetBrains Mono", monospace' }}
      >
        {operator.unit}
      </div>
      <LoadoutBrief loadout={loadout} side={side} />
    </div>
  );
};

export default OperatorMiniCard;
